var _excluded = ["children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import OlTile from 'ol/layer/Tile';
import React, { Children, cloneElement, Fragment, useEffect, useMemo, useRef } from 'react';
import { useOpenLayers } from '../openlayers-context';
import { getEvents, getOptions } from '../utils';
var allTileOptions = {
  zIndex: undefined,
  label: undefined,
  id: undefined,
  opacity: undefined,
  preload: undefined,
  source: undefined,
  visible: undefined,
  extent: undefined,
  minResolution: undefined,
  maxResolution: undefined,
  useInterimTilesOnError: undefined
};
var allTileEvents = {
  'change:visible': undefined,
  prerender: undefined
};

var TileLayer = _ref => {
  var {
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    map
  } = useOpenLayers();
  var options = getOptions(Object.assign(allTileOptions, props));
  var tileEvents = useMemo(() => getEvents(allTileEvents, props), [props]);
  var layer = useRef(new OlTile(options));
  useEffect(() => {
    if (!map) return;
    var currentLayer = layer.current;

    for (var eventName in tileEvents) {
      // TODO: This should not be any. Fix this.
      currentLayer.on(eventName, tileEvents[eventName]);
    }

    map.addLayer(layer.current);
    return () => {
      map.removeLayer(currentLayer);

      for (var _eventName in tileEvents) {
        // TODO: This should not be any. Fix this.
        currentLayer.un(_eventName, tileEvents[_eventName]);
      }
    };
  }, [map, tileEvents]);
  return /*#__PURE__*/React.createElement(Fragment, null, Children.map(children, child => child && /*#__PURE__*/cloneElement(child, {
    olLayer: layer.current
  })));
};

export default TileLayer;